<template>
  <div>
    <div class="right-title">
      <span>候选人邀请注册</span>
    </div>
    <div class="content-box">
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic" style="width: 400px;">
        <p class=p1>邀请人候选电话:</p>
        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains"
          :key="domain.key"
          :prop="'domains.' + index + '.value'"
          :rules="rules.phone"
        >
          <el-input v-model="domain.value" placeholder="输入电话号码">
            <el-button v-if='index !== 0' slot="append" icon="el-icon-delete"
                       @click.prevent="removeDomain(domain)"></el-button>
          </el-input>

        </el-form-item>
        <el-form-item>
          <el-button @click="addDomain">添加候选人</el-button>
          <br>
          <el-button type="primary" class="yaoq" @click="submitForm('dynamicValidateForm')">一键邀请</el-button>
        </el-form-item>
      </el-form>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "hxrInvitation",
    data() {
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[0-9]\d{9}$/
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return {
        dynamicValidateForm: {
          domains: [{
            value: ''
          }],
        },
        rules: {
          phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {validator: checkPhone, trigger: 'blur'}
          ]
        }
      }

    },
    computed: {},
    created() {
      this.$emit('setType', 5)
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let _arr =[]
            this.dynamicValidateForm.domains.map(item=>{
              _arr.push(item.value)
            })
            this.$api.apiContent.addAllreg({
              adminId:this.$store.state.user.id,
              userPhone:_arr.join(',')
            }).then(() => {
              this.$message.success('已发送邀请短信')
              this.$refs[formName].resetFields()
              this.dynamicValidateForm = {
                domains: [{
                  value: ''
                }],
              }
            }).catch(e => {
              this.$message.success(e.info)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        if (this.dynamicValidateForm.domains.length > 100) {
          this.$message.error('每次最多要起100人')
          return
        }
        this.dynamicValidateForm.domains.push({
          value: '',
          key: Date.now()
        });
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .box {
    width: 500px;
    height: 500px;
    background-color: #999999;
  }

  .yaoq {
    margin-top: 100px;
    margin-left: 130px;
    padding: 13px 45px;
  }

  .p1 {
    width: 100%;
    line-height: 40px;
  }
</style>